import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { useLanguage } from '../../context/LanguageContext';
import { Zap } from 'lucide-react';

const SolutionSection = () => {
  const { t } = useLanguage();
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });
  
  return (
    <section 
      id="solution" 
      ref={ref}
      className="section-spacing relative bg-[#F8FAFC]"
      data-testid="solution-section"
    >
      <div className="section-container relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Icon */}
          <motion.div
            initial={{ opacity: 0, scale: 0.5 }}
            animate={isInView ? { opacity: 1, scale: 1 } : {}}
            transition={{ duration: 0.5 }}
            className="w-16 h-16 mx-auto mb-8 rounded-2xl bg-[#2563EB]/10 flex items-center justify-center"
          >
            <Zap className="w-8 h-8 text-[#2563EB]" />
          </motion.div>
          
          {/* Section Header */}
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6 }}
          >
            <span className="text-[#2563EB] text-sm font-medium tracking-wider uppercase mb-4 block">
              {t.solution.subtitle}
            </span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0F172A] mb-6">
              {t.solution.title}
            </h2>
            <p className="text-lg text-[#475569] max-w-2xl mx-auto leading-relaxed mb-4">
              {t.solution.description}
            </p>
            {t.solution.highlight && (
              <p className="text-xl text-[#0F172A] font-semibold max-w-2xl mx-auto leading-relaxed">
                {t.solution.highlight}
              </p>
            )}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default SolutionSection;
